export default __webpack_public_path__ + "static/media/dashboard.7701cd21.svg";